<template>
  <div id="basicInfo"
       class="part">
    <template v-if="isEdit!=='basic'">
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">Email</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.email || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">Title</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{title[data.titleCode] || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">First Name</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.firstName || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">Last Name</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.lastName || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">Degree / Credential</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)"
             v-if="data.degreesList && data.degreesList.length"> <span v-for="(item,index) in data.degreesList"
                :key="item.id+index">{{item.name}}<font v-if="data.degreesList.length>1 && data.degreesList.length-1!=index">; </font> </span></div>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)"
             v-else>--</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">Academic Rank / Scientific Rank</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.rank && data.rank.name || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">Country / Territory</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.countryCode ? country[data.countryCode]:'--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">City</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.city || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">Interest(s)</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.interest || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">Affiliations</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.affiliation || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:270px">CV</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">
          <ipub-label v-if="data.cv"
                      type="link"
                      size="small">
            <a class="ipub-c-p link-color"
               @click="goToPage(`${domain}/${data.cv}`, data.cvName)">
              {{data.cvName || '--'}}
              <ipub-icon type="iconDownload1" />
            </a>
          </ipub-label>
          <font v-else>--</font>
        </div>
      </div>
    </template>
    <template v-else>
      <ipub-form ref="basic-information-form"
                 :model="form"
                 :rules="rules">
        <ipub-row :gutter="12">
          <ipub-col :span="2">
            <ipub-form-item prop='titleCode'
                            label="Title">
              <ipub-select v-model="form.titleCode"
                           placeholder="Title">
                <ipub-select-option v-for="(value, key) in titleList"
                                    v-show="value.enabled"
                                    :key="key"
                                    :value="value.code">
                  <span>{{ value.name }}</span>
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop='email'
                            label="Email">
              <ipub-input disabled
                          v-model="form.email" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="3">
            <ipub-form-item prop='firstName'
                            label="First Name">
              <ipub-input placeholder="First Name"
                          v-model.trim="form.firstName" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="3">
            <ipub-form-item prop='lastName'
                            label="Last Name">
              <ipub-input placeholder="Last Name"
                          v-model.trim="form.lastName" />
            </ipub-form-item>
          </ipub-col>
          <!-- <ipub-col :span="4">
            <ipub-form-item prop='createTime'
                            label="Created Date">
              <ipub-input disabled
                          :value="$moment(form.createTime)&&$moment(form.createTime).format('MMMM DD YYYY')" />
            </ipub-form-item>
          </ipub-col> -->
        </ipub-row>
        <ipub-form-item prop="affiliation"
                        label="">
          <slot name="title">
            <div class=" ipub-p2 fw-bd mar-b-10">
              Affiliations
              <font class="key-color">*</font>
              <font class="link-color ipub-cursor-pointer mar-l-20"
                    @click="addMore('affiliations')">
                <ipub-icon type="iconAdd" />
                <span class="mar-l-8">Add New Affiliations</span>
              </font>
            </div>
          </slot>
          <div v-for="(item, index) in form.affiliations"
               class="mar-b-10"
               :key="'form.affiliations'+index">
            <ipub-input placeholder="Affiliations"
                        :suffixIcon="index===0?'':'iconClose'"
                        @blur="getMore('affiliation')"
                        @iconClick="delMore('affiliations',index)"
                        v-model.trim="form.affiliations[index]" />
          </div>
          <!-- <ipub-button type="primary"
                       icon="iconAdd"
                       @click="addMore('affiliations')"
                       style="width:240px"
                       plain>Add Affilications</ipub-button> -->
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="countryCode"
                            label="Country / Territory">
              <ipub-select v-model="form.countryCode"
                           search
                           :clear="true"
                           @search="countrySearch"
                           placeholder="Country / Territory">
                <ipub-select-option v-for="item in countryList"
                                    :value="item.code"
                                    :key="'countryList'+item.code">
                  {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="city"
                            label="City">
              <ipub-input placeholder="City"
                          v-model.trim="form.city" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>

        <ipub-row :gutter="12">
          <ipub-col :span="6">
            <ipub-form-item prop="degreesIdList"
                            label="Degree / Credential">
              <ipub-select placeholder="Degree / Credential"
                           mode="multiple"
                           :tree="true"
                           search
                           @search="getDegrees"
                           v-model="form.degreesIdList">
                <ipub-select-option v-for="item in degreesList"
                                    v-show="item.enabled"
                                    :key="item.id"
                                    :value="item.id">
                  {{item.name}}<span v-if="item.otherName">({{item.otherName}})</span>
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="rankId"
                            label="Academic Rank / Scientific Rank">
              <ipub-select v-model="form.rankId"
                           search
                           @search="getAcademic"
                           placeholder="Academic Rank / Scientific Rank">
                <ipub-select-option v-for="item in academicList"
                                    v-show="item.enabled"
                                    :key="item.id"
                                    :value="item.id">{{item.name}}<span v-if="item.otherName">({{item.otherName}})</span></ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="12">
          <ipub-col :span="12">
            <ipub-form-item prop="rcv">
              <div class="mar-b-10 ipub-p2 fw-bd relative"
                   slot="label">
                Curriculum Vitae (Reviewer)
                <ipub-tooltip placement="right"
                              type="dark"
                              class="mar-l-10">
                  <div slot="title">PDF</div>
                  <ipub-icon type="iconInfo" />
                </ipub-tooltip>
              </div>
              <ipub-upload-input :file="form"
                                 _name="cvName"
                                 _path="cv"
                                 class="mar-b-20"
                                 :loading="loading"
                                 :domain="domain"
                                 @delete="delFile('cv')"
                                 @change="(e)=>{handleUpload('cv', e)}" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item label="Interest(s)"
                        prop="interest">
          <ipub-textarea :autoSize="{ cols: '', rows: '5' }"
                         v-model="form.interest" />
        </ipub-form-item>
      </ipub-form>
      <div class="btns">
        <ipub-button plain
                     style="width:180px"
                     type="primary"
                     @click="back">Cancel</ipub-button>
        <ipub-button style="width:180px;margin-left:20px"
                     type="primary"
                     @click="save">Save</ipub-button>
      </div>
    </template>

  </div>
</template>
<script>


import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import help from '@/utils/help'
import person from '@/api/person'
import { settingCountry, settingOption } from '@/api/setting'


export default {
  components: {

  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isEdit: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      form: {
        hindexed: false,
        affiliations: [''],
        reviewJournals: ['']
      },
      rules: {},
      countryList: [],
      // sectionList: [],
      academicList: [],
      degreesList: [],
      titleList: [],
      highDegreeList: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      title: 'getTitle',
      country: 'getCountry',
      degree: 'getDegree',
      user: 'getUser',
      highDegree: 'getHighestDegree'
    })
  },
  watch: {
    isEdit (val) {
      if (val === 'basic') {
        this.form = JSON.parse(JSON.stringify(this.data))
      }
    }
  },
  mounted () {
    this.getData()
    this.getRules()
    this.countrySearch()
  },
  methods: {
    async getData () {
      const academicList = await settingOption.get({ type: 'ACADEMIC_RANK' })
      const degreesList = await settingOption.get({ type: 'DEGREE' })
      const titleList = await settingOption.get({ type: 'TITLE' })
      const highDegreeList = await settingOption.get({ type: 'HIGHEST_DEGREE' })
      this.academicList = academicList
      this.degreesList = degreesList
      this.titleList = titleList
      this.highDegreeList = highDegreeList
    },

    async getAcademic (keyword) {
      this.academicList = await settingOption.get({ keyword, type: 'ACADEMIC_RANK' })

    },
    async getDegrees (keyword) {
      this.degreesList = await settingOption.get({ keyword, type: 'DEGREE' })
    },

    confirm () {
      this.showRank = false
      this.showDegree = false
      this.getAcademic()
      this.getDegrees()
    },

    cancel () {
      this.showRank = false
      this.showDegree = false
    },

    addMore (key) {
      this.form[key].push('')
    },
    delMore (key, index) {
      if (this.form[key].length === 1) {
        return
      }
      this.form[key].splice(index, 1)
    },
    getMore (key) {
      const arr = []
      this.form[key + 's'].forEach(item => {
        if (item) {
          arr.push(item)
        }
      })
      this.form[key] = arr.join(';')
    },

    async countrySearch (val) {
      this.countryList = await settingCountry.getAll({
        keyword: val
      })
    },

    async handleUpload (key, files) {
      const file = files[0]
      const pdfFiles = ['rcv, cv']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(
        file,
        `${this.publisherId}/profile/${this.data.id}/${key}/${help.guid()}`
      )

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.form, key + 'Name', file.name)
      this.$set(this.form, key, url)
    },

    delFile (key) {
      this.form[key] = ''
      this.form[key + 'Name'] = ''
    },

    goToPage (val, name) {
      help.download(val, name)
    },

    async save () {
      // console.log(this.$refs['basic-information-form'], 'this.$refs')
      const flag = this.$refs['basic-information-form'].validate()
      if (flag) {
        this.form.affiliation = this.form.affiliations.join(';')
        await person.edit(this.form.id, this.form)
        this.$message.success({
          title: 'Success',
          content: 'This User has been saved!'
        })
        this.$emit('confirm')
      }
    },

    back () {
      this.$emit('cancel')
    },

    getRules () {
      this.rules = {
        affiliation: [
          {
            required: true,
            message: 'Affiliation' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        // titleCode: [
        //   {
        //     required: true,
        //     message: 'Title' + this.LANGUAGE[this.language].noEmpty
        //   }
        // ],
        firstName: [
          {
            required: true,
            message: 'FirstName' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        lastName: [
          {
            required: true,
            message: 'LastName' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        countryCode: [
          {
            required: true,
            message:
              'Country / Territory' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        city: [
          {
            max: 256,
            message: `City length must not be more than 256 digits`
          }
        ],
        // degreesIdList: [
        //   {
        //     required: true,
        //     message:
        //       'Degree / Credential' + this.LANGUAGE[this.language].noEmpty
        //   }
        // ]
        // degreeCode: [
        //   {
        //     required: true,
        //     message: 'Highest Degree' + this.LANGUAGE[this.language].noEmpty
        //   }
        // ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ipub-block__font {
  overflow-wrap: break-word;
}
.part {
  padding: 4px 16px;
}
</style>
